import { CSSProperties, useState } from "react";
import "./ChevronToggle.scss";
import ChevronDirectionEnum from "../../../models/ChevronDirectionEnum";

type Props = {
    showChevron?: boolean;
    isVisible: boolean;
    toggleFn: () => void;
    className?: string;
    direction?: ChevronDirectionEnum;
    style?: CSSProperties;
};

const ChevronToggle = (props: Props) => {
    // const [isVisible, setIsVisible] = useState(props.isVisible || false);

    const toggleIsVisible = () => {
        if (!props.showChevron) {
            return null;
        }

        // setIsVisible(!isVisible);

        props.toggleFn();
    };

    const chevronDirection = "fa-chevron-down";

    if (props.direction) {
        // chevronDirection = `fa-chevron-${props.direction}`;
    }

    const style = {
        color: props.showChevron ? "" : "rgba(0,0,0,0)",
        ...props.style,
    };

    const classNameArr = [
        "ChevronToggle d-inline-flex align-items-center",
        props.showChevron ? "pointer" : "default",
    ];

    if (props.className) {
        classNameArr.push(props.className);
    }

    return (
        <div
            data-testid={"chevron-toggle"}
            className={classNameArr.join(" ")}
            style={style}
            onClick={toggleIsVisible}
        >

            <div data-testid={"chevron"}>
                <i className={props.isVisible ? "fas fa-chevron-up" : ("fas " + chevronDirection)} />
            </div>
        </div>
    );
}

export default ChevronToggle;
